import React,{Component} from 'react';
import connect from "react-redux/es/connect/connect";
import {Link} from "react-router-dom";
import * as wActs from "../../actions/website-actions";
class OrderAccepted extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }


  getTranId() {
    let oid = "";
    let tid = "";
    if(!wActs.isNullOrEmpty(this.props.OrderId)) {
      oid = this.props.OrderId;
    }
    if(!wActs.isNullOrEmpty(this.props.TransactionId)) {
      tid = this.props.TransactionId;
    }
    let ret =  oid + (wActs.isNullOrEmpty(tid) ? "" : "-" + tid);
    return ret;
  }

  getTranslation(key)
  {
    return this.props.WebPage.Translations[key];
  }

  render() {
    return (
      <React.Fragment>
        <div className="large-text green" style={{marginBottom: "25px"}}><i className="fa fa-thumbs-up"></i>&nbsp;&nbsp;&nbsp;{this.getTranslation("page.advertise.orderapproved")}</div>
        <div className="medium-text">{this.getTranslation("page.advertise.yourorderisapprovedtext")}</div>
        {!wActs.isNullOrEmpty(this.props.OrderId) &&
        <div className="medium-text">{this.getTranslation("page.advertise.yourreferencenumber").replace("page.advertise.yourreferencenumber").replace("{{Number}}",this.getTranId())}</div>
        }
        <div className="medium-text" dangerouslySetInnerHTML={{__html: this.getTranslation("page.advertise.ifyouhaveanyquestionsaboutyourorder").replace("{{SupportUrl}}",wActs.getCultPath(this.props.WebPage,"/support"))}}></div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(OrderAccepted);




